// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"4f45bec0","472":"a9e270d6","747":"13b0ed7a","787":"abc7b64d","915":"a87bcab1"}[chunkId] + ".chunk.js";
};